import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import Icon from './Icon';
import '../styles/components/darkModeToggle.css';

const DarkModeToggle = () => {
    const { darkMode, toggleDarkMode } = useTheme();
    
    return (
        <button 
            className={`dark-mode-toggle ${darkMode ? 'dark' : 'light'}`}
            onClick={toggleDarkMode}
            aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        >
            <Icon name={darkMode ? 'sun' : 'moon'} />
            <span className="toggle-text">{darkMode ? 'Light' : 'Dark'}</span>
        </button>
    );
};

export default DarkModeToggle;